import React from 'react'
import { Row, Card, CardBody } from 'reactstrap'

const DefaultPage = () => {
  return (
    <div className='content'>
        <Row>
            <Card>
                <CardBody>
                <h1>Default Page</h1>
                </CardBody>
            </Card>
        </Row>
      
    </div>
  )
}

export default DefaultPage
